export default {
  activityLogData: [],
  meta: {}
};